export default function duration(minutes: number): string {
  return minutes >= 180 ? `${toHours(minutes)} h` : `${minutes} min`;
}

function toHours(val: number) {
  return Math.round(val / 60);
}
